import React from 'react'
import Typography from 'material-ui/Typography'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormHelperText } from 'material-ui/Form'
import { ModalHeader, ModalContents, ModalFooter } from '../../../common/modal'

import { withStyles } from 'material-ui/styles'
import styles from '../../manufacturer/upload/styles'


class UploadFiber extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      modal : false
    }
    this.state = {
      fiberapplication : null,
      fiberconnector : null,
      fiberdatabase : null,
      errors:{

      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.uploadLimitsDbFile = this.uploadLimitsDbFile.bind(this)
  }
  handleChange(e) {
    let errors = {...this.state.errors}
    if(e.target.type=='file' && e.target.files.length){
      let fileExtention = e.target.files[0].name.split('.').pop()
      if(fileExtention === 'json'){
        this.setState({
          [e.target.name] : e.target.files[0],
          errors : {
            ...errors,
            [e.target.name] : false
          }
        })
      }else{
        this.setState({
          errors : {
            ...errors,
            [e.target.name] : true
          }
        })
      }
    }
  }
  uploadLimitsDbFile(e) {
    e.preventDefault()
    let cablefile = this.state.fiberapplication
    let connectorfile = this.state.fiberconnector
    let cabledatabase = this. state.fiberdatabase
    var fd = new FormData();
    if(cablefile && connectorfile && cabledatabase){
      if(cablefile){
        fd.append('fiberfiles', cablefile)
        fd.append('fiberapp',cablefile.name)
      }
      if(connectorfile){
        fd.append('fiberfiles', connectorfile)
        fd.append('fiberstd',connectorfile.name)
      }
      if(cabledatabase) {
        fd.append('fiberfiles', cabledatabase)
        fd.append('fibercable',cabledatabase.name)
      }
      this.props.uploadFiberFilesDb(fd)
      this.props.onClose()
    }

  }
  render(){
    const { classes, translate, onClose } = this.props
    const { fiberapplication, fiberconnector, fiberdatabase, errors} = this.state
    return (
      <Modal open={true} onClose={onClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("settings_fiberdb_title")}
              </Typography>
            </ModalHeader>
            <ModalContents>
              <form noValidate autoComplete="off" className={classes.form}>
                <FormControl
                  margin='normal'
                  fullWidth
                  error={errors.fiberapplication ? true : false}
                  >
                  <InputLabel htmlFor="fiberapplication" shrink={true} disableAnimation={true}>{translate("settings_fiber_application_label")}</InputLabel>
                  <Input
                      className={classes.upload}
                      id="fiberapplication"
                      type="file"
                      name="fiberapplication"
                      onChange={this.handleChange}
                      inputProps={{
                        accept: ".json",
                        name:"fiberapplication"
                      }}
                  />
                  <FormHelperText id="fiberapplication-helper-text">{translate("settings_cableinfofile_help")}</FormHelperText>
                </FormControl>
                <FormControl
                  margin='normal'
                  fullWidth
                  error={errors.connectorinfofile ? true : false}
                  >
                  <InputLabel htmlFor="fiberconnector" shrink={true} disableAnimation={true}>{translate("settings_fiber_standard_label")}</InputLabel>
                  <Input
                      className={classes.upload}
                      id="fiberconnector"
                      type="file"
                      name="fiberconnector"
                      onChange={this.handleChange}
                      inputProps={{
                        accept: ".json",
                        name:"fiberconnector"
                      }}
                  />
                  <FormHelperText id="fiberconnector-helper-text">{translate("settings_connectorinfofile_help")}</FormHelperText>
                </FormControl>
                <FormControl
                  margin='normal'
                  fullWidth
                  error={errors.connectorinfofile ? true : false}
                  >
                  <InputLabel htmlFor="fiberdatabase" shrink={true} disableAnimation={true}>{translate("settings_fiber_cable_label")}</InputLabel>
                  <Input
                      className={classes.upload}
                      id="fiberdatabase"
                      type="file"
                      name="fiberdatabase"
                      onChange={this.handleChange}
                      inputProps={{
                        accept: ".json",
                        name:"fiberdatabase"
                      }}
                  />
                  <FormHelperText id="fiberdatabase-helper-text">{translate("settings_connectorinfofile_help")}</FormHelperText>
                </FormControl>
              </form>
            </ModalContents>
            <ModalFooter>
              <Button raised
                onClick={onClose}
              >
                {translate('general_cancel')}
              </Button>
              {(fiberapplication && fiberconnector && fiberdatabase) ? (<Button raised
                color="accent"
                type="submit"
                onClick={this.uploadLimitsDbFile}
              >
                {translate("settings_upload")}
              </Button>) : null}

            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    )
  }

}

export default withStyles(styles)(UploadFiber)
